@if (clearButton) {
    <div class="action">
        <ng-content select="fui-clear-button"></ng-content>
    </div>
}
@for (option of filteredOptions; track option[field]; let i = $index) {
    <fui-multiselect-option [field]="field" [key]="key"
                            [option]="option" [attr.id]="'option-' + i"
                            [optionOpenable]="optionOpenable" [attr.option-label]="option[key]"
                            [attr.option-value]="option[field]"
                            [allowLabelMarkup]="allowLabelMarkup"
                            (optionOpened$)="optionOpened$.emit($event)"></fui-multiselect-option>
}
